"use client";

import { supabase } from "@/lib/supabase";
import type { PlatformUpdatesMetricAction } from "@/lib/platform-updates/metrics";

export async function recordPlatformUpdatesMetric(
  action: PlatformUpdatesMetricAction,
  metadata?: Record<string, unknown>,
): Promise<void> {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) return;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 2000);

    const response = await fetch("/api/metrics/platform-updates/events", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({ action, metadata: metadata ?? null }),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      console.warn("Platform updates metrics API returned:", response.status);
    }
  } catch (err) {
    const e = err as { name?: string } | null;
    if (e?.name !== "AbortError") {
      console.warn("Platform updates metric failed:", err);
    }
  }
}
